class UnhandledError extends Error {}
const getErrorMessage = isAsync => isAsync ? 'Unhandled async error' : 'Unhandled error';
const rethrow = (cause, isAsync = false) => {
  setTimeout(() => {
    throw new UnhandledError(getErrorMessage(isAsync), {
      cause
    });
  }, 0);
};
export function safeCallback(fn) {
  const wrapped = (...args) => {
    try {
      const result = fn(...args);
      if (result instanceof Promise) {
        return result.then(() => undefined).catch(err => {
          rethrow(err, true);
        });
      }
    } catch (err) {
      rethrow(err, false);
    }
  };
  return wrapped;
}